
export class BillJobFileLocationDetails {
	public meterNumberIdentifier?: string;
	public rateClass?: string;
	public taxCharge?: number;
	public meterNumber?: string[];
	public city?: string;
	public address1?: string;
	public serviceAddress?: string;
	public deliveryCharge?: number;
	public accountNumberIdentifier?: string;
	public usageHistory?: { month: string; usage: number; }[];
	public accountNumber?: string;
	public zipCode?: string;
	public deliveryRate?: number;
	public supplyCharge?: number;
	public taxRate?: number;
	public supplyRate?: number;
	public totalUsage?: number;
	public state?: string;
	public notes?: string;

	constructor(billJobFileLocationDetails?: BillJobFileLocationDetails) {
		Object.assign(this, billJobFileLocationDetails);
	}
}
